import { Formik, useFormikContext } from "formik";
import {
	initialValues,
	schema,
} from "../../../../../../constants/form/facturacion/filters";
import { Filters, StyledDatePicker } from "./styles";
import { useDispatch } from "react-redux";
import { useEffect, useState } from "react";
import { Center } from "../../../../../../components/StyledComponents";
import { getAllFacturaciones } from "../../../../../../store/actions/facturacion";
import moment from "moment";

const AutoSubmit = () => {
	const formik = useFormikContext();

	useEffect(() => {
		if (formik.values !== formik.initialValues) {
			formik.submitForm();
		}
	}, [formik.values]);

	return null;
};

const Component = ({ setActiveFilters }) => {
	const dispatch = useDispatch();

	const [filters, setFilters] = useState<{ [key: string]: string }>({});

	const [dateRange, setDateRange] = useState<[Date | null, Date | null]>([
		null,
		null,
	]);
	const [startDate, endDate] = dateRange;

	const onSubmit = ({ values }) => {
		Object.keys(values).forEach((key) => {
			if (values[key] === undefined || values[key] === null) {
				delete values[key];
			}
		});

		setActiveFilters?.(values);
		localStorage.setItem("facturacion-filters", JSON.stringify(values));
		dispatch(getAllFacturaciones({ page: 0, limit: 10, filters: values }));
	};

	useEffect(() => {
		const filtersSaved = localStorage.getItem("facturacion-filters");
		if (filtersSaved) {
			const filtersObj = JSON.parse(filtersSaved);
			setFilters(filtersObj);
		}
	}, []);

	useEffect(() => {
		if (Object.keys(filters).length > 0) {
			dispatch(getAllFacturaciones({ page: 0, limit: 10, filters }));
		}
	}, [filters]);

	return (
		<Filters>
			<span style={{ marginRight: "10px" }}>Filtrar: </span>

			<Formik
				initialValues={{ ...initialValues, ...filters }}
				onSubmit={(values) => onSubmit({ values })}
				validationSchema={schema}
				enableReinitialize
			>
				{({ handleSubmit, setFieldValue }) => (
					<form
						className="theme-form"
						onSubmit={(event) => {
							handleSubmit(event);
						}}
						id="facturacion-filters-form"
					>
						<Center horizontal="center" vertical="center">
							<StyledDatePicker
								selectsRange
								startDate={startDate}
								endDate={endDate}
								onChange={(update: any) => {
									const [start, end] = update;
									if (start) {
										setFieldValue(
											"startDate",
											moment(start).format("YYYY-MM-DD")
										);
									} else {
										setFieldValue("startDate", null);
									}

									if (end) {
										setFieldValue("endDate", moment(end).format("YYYY-MM-DD"));
									} else {
										setFieldValue("endDate", null);
									}

									setDateRange(update);
								}}
								placeholderText="Rango de fechas"
								isClearable
							/>
							<AutoSubmit />
						</Center>
					</form>
				)}
			</Formik>
		</Filters>
	);
};

export default Component;
